import { filter } from "lodash";
import React, { useState, useEffect } from "react";

interface GradientShadowProps {
    position?: string; // Tailwind classes like "top-0 right-0", "bottom-0 left-0", etc.
    className?: string; // Optional additional classes
}

const GradientShadow: React.FC<GradientShadowProps> = ({
    position = "top-0 right-0",
    className = "",
}) => {
    return (
        <div
            className={`absolute ${position} w-[140px] h-[200px] bg-[#F2A104] rounded-full ${className}`} style={{'filter':'blur(170px)'}}
        />
    );
};

export default GradientShadow;